import React, { useRef, useState, useEffect } from 'react';
import { connect } from 'react-redux';

import { getHoldsColumns } from './table/getColumns';
import { Table } from '../../../../components/table';
import { HoldsLogModal } from '../../../../components/modal';

import {

} from '../../../../actions';

const defaultSorted = { dataField: 'date_created', order: 'desc' };

function Component(props){
    const mounted = useRef(false);
    useEffect(() => {
        mounted.current = true;
        return () => (mounted.current = false);
    });
    
    const [modalMode, setModalMode] = useState(null);
    const [selectedLog, setSelectedLog] = useState(null);

    const { holdsLogs, refreshData } = props;

    function handleShowModal(mode, entry){
        setModalMode(mode);
        setSelectedLog(entry);
    }
    function onSubmitCallback(changes = false){
        setModalMode(null);
        setSelectedLog(null);
        if(changes) refreshData();
    }

    const columns = getHoldsColumns(handleShowModal);

    return (
        <div>
            {modalMode && 
                <HoldsLogModal
                    mode={modalMode}
                    selectedLog={selectedLog}
                    onSubmitCallback={onSubmitCallback}
                />
            }
            <Table
                tableName="holdsLogs"
                data={holdsLogs}
                columns={columns}
                defaultSorted={defaultSorted}
                emptyMessage="No holds were found"
            />
        </div>
    );
}

export default connect(null, {

})(Component);